import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, FocusTrap, NumberInput, Select, Loader, Text } from '@mantine/core'
import { DateInput } from '@mantine/dates'
import { useUserCreditForm } from './schema/form'
import { useSelector, useDispatch } from 'react-redux'
import { getAllOrderList } from '../../../../../services/orders'
import { useDebouncedCallback } from "@mantine/hooks"
import { addCommisionUser, updateCommisionUser } from '../../../../../services/users'
import { notificationSuccess, notificationError } from '../../../../ui/Notifications'
import { getUserDetail } from '../../../../../store/userDetail'

const defaultTypeBalance = [
  {
    value: 'increase',
    label: 'Increase'
  },
  {
    value: 'decrease',
    label: 'Decrease'
  }
]


const FormAdjustBalanceUser = ({ userId, dataBalance, onCloseForm, reloadList }) => {
  const dispatch = useDispatch()
  const { balanceHistory } = useSelector((state) => state.user_detail)
  const form = useUserCreditForm()

  const dataSupplier = balanceHistory.supplierList
  const filteredOwnerSupplier = dataSupplier.filter((item) => item.attributes.pivot.supplier_type === 'owner')

  const [loadingForm, setLoadingForm] = useState(false)
  const [orderList, setOrderList] = useState([])
  const [loadingOrder, setLoadingOrder] = useState(true)
  const [searchOrder, setSearchOrder] = useState('')
  const [supplierList, setSupplierList] = useState([])

  const handleGetListOrder = useDebouncedCallback(async (orderId) => {
    setLoadingOrder(true)
    const parameter = {
      'filter[id][is]': orderId,
      'filter[order_code][like]': searchOrder,
      'page[num]': 1,
      'page[limit]': 10, // bad habbit
      sort: '-created_at'
    }

    try {
      const response = await getAllOrderList(parameter)
      if (response.success) {
        const dataCity = response.data
        const remapDataOrder = dataCity.map((val) => {
          return {
            value: `${val.attributes.id}`,
            label: val.attributes.order_code
          }
        })
        setOrderList(remapDataOrder)
      } else {
        setOrderList([])
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingOrder(false)
    }
  }, 300)

  const submitUserCredit = async (form) => {
    setLoadingForm(true)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''

    const payload = {
      ...form,
      currency: balanceHistory.signupcountry.currency,
      user_id: Number(userId)
    }

    if (dataBalance !== null) {
      methodFunction = updateCommisionUser(dataBalance.id, payload)
      titleMessageSuccess = 'Update User Credit Success'
      captionMessageSuccess = 'User Credit has been updated successfully.'
      titleMessageError = 'Update User Credit Failed'
      captionMessageError = 'User Credit failed to update, please try again.'
    } else {
      methodFunction = addCommisionUser(payload)
      titleMessageSuccess = 'Create User Credit Success'
      captionMessageSuccess = 'User Credit has been created successfully.'
      titleMessageError = 'Create User Credit Failed'
      captionMessageError = 'User Credit failed to create, please try again.'
    }

    try {
      const response = await methodFunction
      if (response.success) {
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
        setLoadingForm(false)
        reloadList()
        dispatch(getUserDetail(userId))
        onCloseForm()
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      notificationError(titleMessageError, errorMessage ? errorMessage : captionMessageError)

      const errorMessageForm = error.response.data.errors
      if (errorMessageForm) {
        Object.keys(errorMessageForm).forEach((key) => {
          form.setFieldError(key, errorMessageForm[key][0])
        })
      }
      setLoadingForm(false)
    }
  }

  const defaultListIncrease = [
    {
      value: 'Bonus',
      label: 'Bonus',
      disabled: false
    },
    {
      value: 'Order Commision',
      label: 'Order Commision',
      disabled: false
    },
    {
      value: 'Balance Adjustment',
      label: 'Balance Adjustment',
      disabled: false
    },
    {
      value: 'Sales',
      label: 'Sales',
      disabled: filteredOwnerSupplier.length > 0 ? false : true
    }
  ]

  const defaultListDecrease = [
    'Withdrawal',
    'Balance Adjustment'
  ]

  useEffect(() => {
    handleGetListOrder()
    // eslint-disable-next-line
  }, [searchOrder])

  useEffect(() => {
    if (dataBalance !== null) {
      handleSetForm(dataBalance)
    }
    // eslint-disable-next-line
  }, [dataBalance])

  useEffect(() => {
    if (filteredOwnerSupplier.length > 0) {
      const remapDataSupplier = filteredOwnerSupplier.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setSupplierList(remapDataSupplier)
    }
    // eslint-disable-next-line
  }, [])

  const handleSetForm = (data) => {
    if (data.order_id !== null) {
      handleGetListOrder(data.order_id)
    }
    const detail = {
      date: new Date(data.updated_at),
      amount: `${data.amount ? data.amount : 0}`,
      method: data.commission_type === 1 ? 'increase' : 'decrease',
      label: data.label,
      order_id: data.order_id ? `${data.order_id}` : '',
      supplier_id: data.supplier_id ? `${data.supplier_id}` : ''
    }

    form.initialize(detail)
    form.setValues(detail)
  }

  const loadingDataTemplate = () => {
    return (
      <Box ta='center' my={12}>
        <Loader size={16} />
        <Text c='gray.6' fz={11}>Loading Data</Text>
      </Box>
    )
  }

  const loadFormSupplier = (typeLabel) => {
    if (typeLabel === 'Sales') {
      return (
        <Box mb='sm'>
          <Select
            label='Supplier'
            data={supplierList}
            key={form.key('supplier_id')}
            {...form.getInputProps('supplier_id')}
            size='xs'
            withAsterisk
            allowDeselect={false}
            nothingFoundMessage={!loadingOrder ? supplierList.length > 0 ? '' : 'No Order Code Found' : loadingDataTemplate()}
            clearable
          />
        </Box>
      )
    }
  }

  const loadFormOrder = (typeLabel) => {
    if (typeLabel === 'Order Commision' || typeLabel === 'Sales') {
      return (
        <Box mb='sm'>
          <Select
            label='Order Code'
            data={orderList}
            key={form.key('order_id')}
            {...form.getInputProps('order_id')}
            size='xs'
            withAsterisk
            searchable
            allowDeselect={false}
            searchValue={searchOrder}
            onSearchChange={setSearchOrder}
            nothingFoundMessage={!loadingOrder ? orderList.length > 0 ? '' : 'No Order Code Found' : loadingDataTemplate()}
            clearable
          />
        </Box>
      )
    }
  }

  return (
    <Box>
      <FocusTrap.InitialFocus />
      <Box mb='sm'>
        <DateInput
          label="Date"
          placeholder="Date input"
          valueFormat="DD MMMM YYYY"
          key={form.key('created_at')}
          {...form.getInputProps('created_at')}
          clearable
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mb='sm'>
        <NumberInput
          label="Point Amount"
          placeholder="Input point amount"
          key={form.key('amount')}
          {...form.getInputProps('amount')}
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mb='sm'>
        <Select
          label="Type Method"
          placeholder='Select Type Method'
          data={defaultTypeBalance}
          key={form.key('method')}
          {...form.getInputProps('method')}
          onChange={(val) => form.setValues((prev) => ({ ...prev, method: val, label: null }))}
          allowDeselect={false}
          size='xs'
          withAsterisk
        />
      </Box>
      <Box mb='sm'>
        <Select
          label="Type Credit"
          placeholder='Select Type Credit'
          data={form.getValues().method === 'increase' ? defaultListIncrease : defaultListDecrease}
          key={form.key('label')}
          {...form.getInputProps('label')}
          allowDeselect={false}
          size='xs'
          withAsterisk
        />
      </Box>
      {loadFormSupplier(form.getValues().label)}
      {loadFormOrder(form.getValues().label)}
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" onClick={form.onSubmit((value) => { submitUserCredit(value) }, (error) => { console.log('aaaa', error) })}>{dataBalance !== null ? 'Update' : 'Create'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAdjustBalanceUser